import React from "react";

import RelatorioDinamicoFormPageContainer from "./RelatorioDinamicoFormPageContainer";

export class RelatorioDinamicoFormPage extends React.Component {
  render() {
    return <RelatorioDinamicoFormPageContainer {...this.props} />;
  }
}
